import { FetchError } from '@/connection/helpers';
import toastTrigger from '@ui/toast/toast-trigger';
import { EToastTypes } from '@ui/toast/toast.types';

const handleImageUploadErrors = (error: unknown, errorMessage?: string) => {
  let _errorMessage = errorMessage || 'Error saving image';
  if (error instanceof FetchError) {
    if (error.response.status === 429) {
      _errorMessage = 'Too many requests, please wait a few seconds and try again.';
    }
  }
  toastTrigger(_errorMessage, {
    type: EToastTypes.error,
    closeButton: false,
    closeOnClick: false,
    autoClose: 12000, // we rate limit for 12 seconds in the api, so setting this timeout to that duration
  });
};

export default handleImageUploadErrors;
